import { Component, OnInit, Input, OnChanges } from '@angular/core';
import { UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { ContactFormGQL } from './contact-form.gql';
import { propertySearchFn } from 'src/app/shared/functions/propertySearchFn';
import { brandByExternalId_brandByExternalId_properties } from 'src/app/shared/graphql/types/brandByExternalId';
import { PropertyService } from 'src/app/shared/services/property.service';

@Component({
  selector: 'app-contact-form',
  templateUrl: './contact-form.component.html',
  styleUrls: ['./contact-form.component.scss']
})
export class ContactFormComponent implements OnInit, OnChanges {
  @Input() propertyId: string;
  contactForm: UntypedFormGroup;
  showSuccess: boolean;
  showError: boolean;
  properties: brandByExternalId_brandByExternalId_properties[] = [];
  propertyLoading: boolean;
  propertySearchFn = propertySearchFn;

  constructor(fb: UntypedFormBuilder, private contactFormGQL: ContactFormGQL, private propertyService: PropertyService) {
    this.contactForm = fb.group({
      name: new UntypedFormControl(null, Validators.required),
      phone: new UntypedFormControl(null),
      email: new UntypedFormControl(null, Validators.required),
      description: new UntypedFormControl(null, Validators.required),
      propertyId: new UntypedFormControl(null, Validators.required),
      subscribe: new UntypedFormControl(true)
    });
  }

  ngOnInit(): void {
    if(!this.propertyId) {
      this.getBrandDetails();
    }
  }

  ngOnChanges() {
    this.showSuccess = false;
    this.contactForm.patchValue({
      propertyId: this.propertyId
    });
  }

  onSubmit() {
    this.showError = false;
    this.contactFormGQL
    .mutate({
      ContactFormSubscriberDtoInput: this.contactForm.value
    })
    .subscribe({
      next: ({ data }) => {
        if (data.sendEmail.success) {
          this.showSuccess = true;
        } else {
          this.showError = true;
        }
      },
      error: () => {
        this.showError = true;
      }
    });
  }

  getBrandDetails() {
    this.propertyLoading = true;
    this.propertyService.brand$.subscribe(res=> {
      this.properties = res.properties;
      this.propertyLoading = false;
    });
  }
}
